// @flow
import clsx from 'clsx'
import React, { useEffect } from 'react'
import useReactRouter from 'use-react-router'
import { Meteor } from 'meteor/meteor'
import { isMobile } from 'react-device-detect'

import { Container, makeStyles } from '@material-ui/core'
import useIsMobile from '../hooks/useIsMobile'

import Footer from './Footer'
import HelpBlock from './HelpBlock'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { useGlobalState } from '../store'
import getRoutes from '../routes'
import { useGetSubRoutes } from '../lib/routes'
import type { GlobalState } from '../types/globalState'
import AlertDialog from './Dialog'
import { closeAlertDialog } from '../fonction'
import PageMobile from './PageMobile'
import LAYOUT from '../constants/layout'

type Props = {
  children: any,
}

const useFetchSubRoute = (): Array<Object> => {
  const { history } = useReactRouter()

  const compare =
    history.location.pathname === '/' ? '/' : history.location.pathname.replace(/\/$/, '')

  // On supprime le dernier / volontairement sinon la page n'est pas trouvée dans la liste des routes et une erreur JS entraine une page blanche
  const activePage = getRoutes().filter((i) => i.path === compare)

  const subMenu = useGetSubRoutes(activePage ? activePage[0]?.typeRoute : '')

  return !!activePage ? subMenu : []
}

const useStyle = makeStyles({
  root: {
    background: '#f5f6fa',
  },
  mainContainer: {
    width: '100%',
  },
  row: {
    display: 'flex',
  },
  fullPage: {
    width: '100%',
    maxWidth: 1024,
    margin: '0 auto',
    paddingTop: 32,
    paddingBottom: 32,
    display: 'block',
  },
})

const Layout = ({ children }: Props) => {
  const { history, location } = useReactRouter()
  const [alertDialog] = useGlobalState('alertDialog')
  const classes = useStyle()
  const isMobile = useIsMobile()

  const subMenu = useFetchSubRoute()

  useEffect(() => {
    if (window.rudderanalytics) window.rudderanalytics.page('default', location.pathname, location)
  }, [location.pathname])

  const userObject = Meteor.user()
  const user = !!userObject

  // Push data to segment
  useEffect(() => {
    pushIdentityToSegment()
  }, [user])

  const pushIdentityToSegment = () => {
    const user = Meteor.user()

    const email = user?.emails?.[0]?.address

    if (window.rudderanalytics && user) {
      window.rudderanalytics.identify(Meteor.userId(), {
        name: `${user.profile.firstname} ${user.profile.lastname}`,
        company: user.profile.company,
        email,
        traits: {
          id: Meteor.userId(),
          email,
          name: `${user.profile.firstname} ${user.profile.lastname}`,
          company: user.profile.company,
          type: user.profile.type,
          phone: user.profile.phone,
          is_pro: !!user.profile.pro,
        },
      })
    }
  }

  const isExternalSignupFlow = [
    '/signup',
    '/privacy',
    '/register-profile',
    '/register-profile-category',
    '/register-profile-pro',
    '/register-profile-lawyer',
    '/signup-lawyer',
    '/register-profile-lawyer-price',
    '/register-lawyer-address',
    '/register-profile-lawyer-customers',
    '/register-profile-lawyer-promise',
    '/login',
    '/register-profile-lawyer-card',
    '/register-profile-lawyer-skills',
    '/register-lawyer-upload-picture',
    '/register-lawyer-additional-data',
    '/register-lawyer-profile-schedule',
    '/forgot-password',
  ].includes(window.location.pathname)

  if (window.location.pathname !== '/' && isMobile) return <PageMobile />

  return (
    <div className={classes.root}>
      <AlertDialog
        open={alertDialog.open}
        onClose={() => closeAlertDialog()}
        title={alertDialog.title}
        message={alertDialog.message}
      />
      <Navbar />

      <main className={clsx([classes.mainContainer])} style={{}}>
        <div className={clsx([isExternalSignupFlow && classes.fullPage])}>
          {subMenu.length > 0 ? (
            <div className={classes.row}>
              <Sidebar subMenu={subMenu} path={history.location.pathname} />
              <div style={{ padding: 32, flexGrow: 1 }}>{children}</div>
            </div>
          ) : (
            children
          )}
        </div>
      </main>

      <HelpBlock />

      <Footer />
    </div>
  )
}

export default Layout
